import { GHLLanguageKeys as e } from "./ghl-ui.es285.js";
const r = {
  name: e.danish,
  global: {
    undo: "Fortryd",
    redo: "Gentag",
    confirm: "Bekræft",
    clear: "Ryd",
    more: "mere",
    cancel: "Aflyse"
  },
  Popconfirm: {
    positiveText: "Bekræft",
    negativeText: "Annuller"
  },
  Cascader: {
    placeholder: "Vælg venligst",
    loading: "Indlæser",
    loadingRequiredMessage: () => null
  },
  Time: {
    dateFormat: "yyyy-MM-dd",
    dateTimeFormat: "yyyy-MM-dd HH:mm:ss"
  },
  DatePicker: {
    yearFormat: "yyyy",
    monthFormat: "MMM",
    dayFormat: "eeeeee",
    yearTypeFormat: "yyyy",
    monthTypeFormat: "yyyy-MM",
    dateFormat: "yyyy-MM-dd",
    dateTimeFormat: "yyyy-MM-dd HH:mm:ss",
    quarterFormat: "yyyy-qqq",
    clear: "Ryd",
    now: "Nu",
    confirm: "Bekræft",
    selectTime: "Vælg Tid",
    selectDate: "Vælg Dato",
    datePlaceholder: "Vælg Dato",
    datetimePlaceholder: "Vælg Dato og Tid",
    monthPlaceholder: "Vælg Måned",
    yearPlaceholder: "Vælg År",
    quarterPlaceholder: "Vælg Kvartal",
    startDatePlaceholder: "Start Dato",
    endDatePlaceholder: "Slut Dato",
    startDatetimePlaceholder: "Start Dato og Tid",
    endDatetimePlaceholder: "Slut Dato og Tid",
    startMonthPlaceholder: "Start Måned",
    endMonthPlaceholder: "Slut Måned",
    monthBeforeYear: !0,
    firstDayOfWeek: 6,
    today: "I dag"
  },
  DataTable: {
    checkTableAll: "Vælg alt i tabellen",
    uncheckTableAll: "Fravælg alt i tabellen",
    confirm: "Bekræft",
    clear: "Ryd",
    apply: "Anvend",
    filters: "Filtre",
    sort: "Sortere"
  },
  LegacyTransfer: {
    sourceTitle: "Kilde",
    targetTitle: "Mål"
  },
  Transfer: {
    selectAll: "Vælg alle",
    unselectAll: "Fravælg alle",
    clearAll: "Ryd"
  },
  Empty: {
    description: "Ingen data"
  },
  Select: {
    placeholder: "Vælg venligst"
  },
  TimePicker: {
    placeholder: "Vælg tid",
    positiveText: "OK",
    negativeText: "Annuller",
    now: "Nu"
  },
  Pagination: {
    goto: "Gå til",
    selectionSuffix: "side",
    next: "Næste",
    previous: "Tidligere"
  },
  DynamicTags: {
    add: "Tilføj"
  },
  Log: {
    loading: "Indlæser"
  },
  Input: {
    placeholder: "Indtast venligst"
  },
  InputNumber: {
    placeholder: "Indtast venligst"
  },
  DynamicInput: {
    create: "Opret"
  },
  ThemeEditor: {
    title: "Tema Editor",
    clearAllVars: "Ryd alle variabler",
    clearSearch: "Ryd søgning",
    filterCompName: "Filterkomponentnavn",
    filterVarName: "Filtervariabelnavn",
    import: "Import",
    export: "Eksport",
    restore: "Nulstil til standard"
  },
  Image: {
    tipPrevious: "Forrige billede (←)",
    tipNext: "Næste billede (→)",
    tipCounterclockwise: "Mod uret",
    tipClockwise: "Med uret",
    tipZoomOut: "Zoom ud",
    tipZoomIn: "Zoom ind",
    tipClose: "Luk (ESC)",
    tipOriginalSize: "Zoom til original størrelse"
  },
  SortFilter: {
    heading: "Sortér og filtre",
    sortHeading: "Sortér efter",
    newestFirst: "Nyeste først",
    oldestFirst: "Ældste først",
    ascending: "Stigende",
    descending: "Faldende",
    aToZ: "A-Å",
    zToA: "Å-A",
    apply: "Anvend",
    clear: "Ryd",
    cancel: "Annuller",
    filters: "Filtre"
  },
  IconPicker: {
    noMatchingFound: "Ingen matchende resultater fundet"
  },
  Spacing: {
    margin: "Marginer",
    padding: "Polstring",
    reset: "Nulstil",
    errorMsg: "Den angivne værdi er ugyldig"
  },
  BrandColorPicker: {
    brandColors: "Brandfarver",
    noBrandColors: "Du har endnu ikke tilføjet nogen brandfarver.",
    getStarted: "Kom i gang",
    add: "Tilføj",
    default: "Standard"
  }
};
export {
  r as da
};
